module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cimage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Instructions for This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("efore you get into everything I’m going to share with you here, I need you to make a deal with me: Don’t just read this book then walk away like you do with almost every other book you’ve ever read. Because I know what’s going to happen. You’re going to start reading this book and you’re going to be blown away by everything you’re learning. You’re going to make promises to yourself that you’re going to start implementing these strategies and you’re going to daydream about all the money you’re going to make when you do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But here’s the thing. As soon as you close the book, your regular life is going to be there staring you in the face. Maybe there’s a load of laundry that needs to be switched over or there are calls you have to make or an appointment you have to get to. Whatever it is, it’s going to feel a lot more demanding than something you read in a book once—regardless of how mind-blowing it was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, I’m going to give you a blueprint on exactly how to use this book so that you actually use this book:")]), _vm._v(" "), _c('div', {
    staticClass: "blk"
  }, [_c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Mess it up:")]), _vm._v(" Underline everything you want to remember. Write in the margins. Use a highlighter. Make this book yours. If it’s something you read and decide you want to share with someone, buy them their own copy. When you use the book like this, it deepens your engagement and helps you remember more of what you’re reading.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Use sticky notes:")]), _vm._v(" Do yourself a favor and don’t turn another page before you go and get a stack of sticky notes to keep next to you. Flag the action items you are committed to doing and the things you want to come back to.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Set goals:")]), _vm._v(" Better yet, write down a deadline on those sticky notes before you put them in your book. Set goals and make commitments as you go.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentn"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Read it again:")]), _vm._v(" I promise you, there are things you’re going to forget and there are things that maybe you’re not ready to hear today but the next time you read it you will be. That’s why it’s important that you read this book more than once. Today, maybe you’re just worried about fixing your credit. But a year from now—especially if you’ve been using the strategies I’m giving you—you might be a lot more interested in how to avoid paying tens of thousands of dollars in taxes or how to buy houses using other people’s money.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whatever you do, don’t just treat this like a book.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s not supposed to be.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0719f20f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm05.vue
// module id = 81
// module chunks = 0